import { render, staticRenderFns } from "./bambooIndex.vue?vue&type=template&id=a945d998&"
import script from "./bambooIndex.vue?vue&type=script&lang=js&"
export * from "./bambooIndex.vue?vue&type=script&lang=js&"
import style0 from "./bambooIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports